module.exports = __webpack_public_path__ + "static/media/filterbutton.66a7d03c.svg";